import Enum from './enum'

class Errors extends Enum
{
  constructor(value, data) {
    super(value);
    this.details = (data || {}).details;
  }
}

Errors.init({
  ACCESS_DENIED: 'Denied',
  INVALID_PASSWORD: 'InvalidPassword',
  TOO_MANY_REQUESTS: 'Delay30Seconds',
  UNKNOWN: 'Unknown',
  PHONE_BUSY: 'PhoneBusy',
  EMAIL_BUSY: 'LoginBusy',
  NOT_FILLED: 'NotFilled',
  NOT_FOUND: 'NotFound',
  BAD_PASSWORD: 'BadPassword',
  INVALID_INVITE_CODE: 'InvalidInviteCode',
  INACTIVE: 'Inactive',
  INVALID_STATE: 'InvalidState',
  BAD_SIGNATURE: 'BadSign',
  INVALID_FILE: 'InvalidFile',
  ALREADY_EXISTS: 'AlreadyExists',
  INVALID_LOT: 'InvalidLot',
  BAD_PAYMENT_TYPE: 'BadPaymentType',
  EXCEEDED_PRICE_LOW_THRESHOLD: 'EdgePrice',
  TOO_HIGH_COST: 'TooHigh',
  ACCREDITATION_EXPIRED: 'NotAccreditate',
  INVALID_TYPE: 'InvalidType',
  INVALID_DATA: 'IncorrectData',
  LOGIC_ERROR: 'Logic',
  BAD_PAYMENTS: 'BadPaymentDo',
  BAD_PAYMENT_CONDITIONS: 'BadPayment',
  BAD_SPECIFICATION: 'BadSpecification',
  BID_WORSE: 'BidWorse',
  INVALID_BLACK_BOX: 'InvalidBlackBox',
  UNKNOWN_SIGNATURE: 'CertNotRegistred'
}, {
  UNKNOWN: 'errors.unknown',
  ACCESS_DENIED: 'errors.access-denied',
  INVALID_PASSWORD: 'errors.invalid-password',
  TOO_MANY_REQUESTS: 'errors.too-many-requests',
  PHONE_BUSY: 'errors.phone-busy',
  EMAIL_BUSY: 'errors.email-busy',
  NOT_FILLED: 'errors.not-filled',
  BAD_PASSWORD: 'errors.bad-password',
  INVALID_INVITE_CODE: 'errors.invalid-invite-code',
  INACTIVE: 'errors.inactive',
  INVALID_STATE: 'errors.invalid-state',
  BAD_SIGNATURE: 'error.bad-signature'
});

export default Errors;
